import OfferInclusionItem from 'components/Common/Inclusions/OfferInclusionItem'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import React from 'react'
import AccommodationPackageInclusionsList from 'components/AccommodationKit/AccommodationPackageInclusionsList'

interface Props {
  inclusions: Array<App.PackageInclusion>;
  bonusInclusions: Array<App.PackageInclusion>
  size?: 'small' | 'medium' | 'large';
}

function InclusionsSection(props: Props) {
  const { inclusions, bonusInclusions, size = 'medium' } = props

  return <VerticalSpacer gap={12}>
    {!!bonusInclusions.length && <AccommodationPackageInclusionsList title="bonus">
      {bonusInclusions.map((inclusion) => <OfferInclusionItem key={inclusion.id} inclusion={inclusion} size={size} />)}
    </AccommodationPackageInclusionsList>}
    <AccommodationPackageInclusionsList title={bonusInclusions.length ? 'additional' : undefined}>
      {inclusions.map((inclusion) => <OfferInclusionItem key={inclusion.id} inclusion={inclusion} size={size} />)}
    </AccommodationPackageInclusionsList>
  </VerticalSpacer>
}

export default InclusionsSection
